'use client';

import { c as _c } from "react/compiler-runtime";
import 'keen-slider/keen-slider.min.css';
import { CarouselContent } from '@src/components/Carousel/CarouselContent';
import { type CarouselProps } from './CarouselProps';
import { useCarouselHandlers } from './useCarouselHandlers';

/**
 * Carousel component that handles it's own state internally.
 */
export function Carousel(props) {
  const $ = _c(9);
  const {
    isLoaded,
    moveOnKeyPress,
    sliderRef,
    instanceRef,
    previousSlide,
    nextSlide,
    currentSlide
  } = useCarouselHandlers(props);
  let t0;
  if ($[0] !== currentSlide || $[1] !== instanceRef || $[2] !== isLoaded || $[3] !== moveOnKeyPress || $[4] !== nextSlide || $[5] !== previousSlide || $[6] !== props || $[7] !== sliderRef) {
    t0 = <CarouselContent {...props} isLoaded={isLoaded} moveOnKeyPress={moveOnKeyPress} sliderRef={sliderRef} instanceRef={instanceRef} previousSlide={previousSlide} nextSlide={nextSlide} currentSlide={currentSlide} />;
    $[0] = currentSlide;
    $[1] = instanceRef;
    $[2] = isLoaded;
    $[3] = moveOnKeyPress;
    $[4] = nextSlide;
    $[5] = previousSlide;
    $[6] = props;
    $[7] = sliderRef;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
}